import { useCallback, useMemo } from 'react';
import { toDecimal } from 'utils/to-decimal';
import * as Yup from 'yup';


export const useFormTaxasValidation = () => {

    //Valido se o valor de venda é maior ou igual ao valor de custo de cada campo
    const validarVendaCusto = useCallback((field: 'percentual', nomeCampoComparacao: string) => {
        const campoValor = field.slice(5, field.length)
        const nomeCampo = field.includes('percentual') ? 'Taxa' : `Valor ${campoValor}`
        return {
            message: `${nomeCampo} não pode ser menor que o custo ${nomeCampoComparacao === 'taxaVendaSoftwareHouse'
                ? 'original'
                : 'vigente'
                }.`,
            test: (value: string | undefined, context: any) => {
                debugger
                const valorCampo = toDecimal(value || '0');
                const fromArr = Array.isArray(context?.from) ? context.from : [];
                let valorComparacaoRaw = undefined;
                for (let i = 0; i < fromArr.length; i++) {
                    const candidate = fromArr[i]?.value?.[nomeCampoComparacao]?.percentual;
                    if (candidate !== undefined && candidate !== null) {
                        valorComparacaoRaw = candidate;
                        break;
                    }
                }
                if (valorComparacaoRaw === undefined) {
                    valorComparacaoRaw = context?.parent?.[nomeCampoComparacao]?.percentual;
                }
                const valorCampoComparacao = toDecimal(valorComparacaoRaw ?? '0');
                return valorCampo >= valorCampoComparacao;
            }
        }
    }, [])

    const FormTaxasValidationYup = useMemo(() => {
        return Yup.object().shape({
            taxaCustoRevenda: Yup.object().shape({
                percentual: Yup.string().required('Informe a Taxa').test(validarVendaCusto('percentual', 'taxaVendaSoftwareHouse')),
            }),
            taxaCustoCliente: Yup.object().shape({
                percentual: Yup.string().required('Informe a Taxa').test(validarVendaCusto('percentual', 'taxaCustoRevenda')),
            })
        })
    }, [validarVendaCusto])

    return {
        FormTaxasValidationYup,
    }
}
